"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var LoyaltyTypes;
(function (LoyaltyTypes) {
    LoyaltyTypes["PER_VISIT"] = "visit";
    LoyaltyTypes["PER_SPEND"] = "spend";
})(LoyaltyTypes = exports.LoyaltyTypes || (exports.LoyaltyTypes = {}));
var AddOrEditLoyaltyTier = /** @class */ (function () {
    function AddOrEditLoyaltyTier() {
        var _this = this;
        this.name = '';
        this.description = '';
        this.creditAmount = 100;
        this.creditAmountPer = 10000;
        this.minimumRequiredPurchase = 0;
        this.minimumRedeemable = 0;
        this.maximumRedeemable = null;
        this.isDefault = false;
        this.changed = false;
        this.updateAllCustomers = false;
        this.type = LoyaltyTypes.PER_VISIT;
        setTimeout(function () {
            mobx_1.observe(_this, function () {
                _this.changed = true;
            });
        }, 100);
    }
    Object.defineProperty(AddOrEditLoyaltyTier.prototype, "networkObject", {
        get: function () {
            return {
                id: this.id,
                name: this.name,
                description: this.description,
                creditAmount: this.creditAmount,
                creditAmountPer: this.creditAmountPer,
                minimumRequiredPurchase: this.minimumRequiredPurchase,
                minimumRedeemable: this.minimumRedeemable,
                maximumRedeemable: this.maximumRedeemable,
                isDefault: this.isDefault,
                type: this.type,
            };
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "description", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "creditAmount", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "creditAmountPer", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "minimumRequiredPurchase", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "minimumRedeemable", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "maximumRedeemable", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "isDefault", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "changed", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "updateAllCustomers", void 0);
    __decorate([
        mobx_1.observable
    ], AddOrEditLoyaltyTier.prototype, "type", void 0);
    return AddOrEditLoyaltyTier;
}());
exports.AddOrEditLoyaltyTier = AddOrEditLoyaltyTier;
//# sourceMappingURL=Loyalty.js.map